import { useMemo } from "react";
import { useQuery } from "@tanstack/react-query";
import { toast } from "react-toastify";

import DataProtectionSoftwareService from "src/modules/data-protection/apis/DataProtectionSoftwareService";

import {
    APPROVAL_REQUIREMENTS_QUERY_KEY,
    getRequiredApprovalsViewMode,
    mapApprovalRequirements,
} from "../helpers";

const useApprovalRequirements = ({ softwareId, t } = {}) => {
    const query = useQuery({
        queryKey: [APPROVAL_REQUIREMENTS_QUERY_KEY, softwareId],
        queryFn: async () => {
            const service = DataProtectionSoftwareService.getInstance();

            return await service.fetchApprovalRequirements(softwareId);
        },
        enabled: Boolean(softwareId),
        refetchOnWindowFocus: false,
        onError: (error) => {
            if (process.env.NODE_ENV === "development") {
                console.error(error);
            }

            toast(t("An error occurred while fetching software details."), {
                type: "error",
            });
        },
    });

    const viewMode = useMemo(() => {
        if (!softwareId) {
            return null;
        }

        return getRequiredApprovalsViewMode(query.data);
    }, [query.data, softwareId]);

    const cards = useMemo(
        () => mapApprovalRequirements(query.data),
        [query.data]
    );

    if (!softwareId) {
        return {
            viewMode: null,
            cards: [],
            isLoading: true,
        };
    }

    return {
        viewMode,
        cards,
        isLoading: query.isLoading,
    };
};

export default useApprovalRequirements;
